import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import {
  FaBars,
  FaTimes,
  FaLinkedin,
  FaFacebook,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa"
import Logo from "../images/avalith-logo.svg"
import LogoWhite from "../images/avalith-logo-white.svg"
import NavMenuHand from "../images/nav-menu-hand.svg"

const Header = ({ siteTitle }) => {
  const [navbarOpen, setNavbarOpen] = useState(false)
  const [navbarSticky, setNavbarSticky] = useState(false)

  const menuBarSicky = () => {
    if (window.scrollY >= 150) {
      setNavbarSticky(true)
    } else {
      setNavbarSticky(false)
    }
  }
  useEffect(() => {
    window.addEventListener("scroll", menuBarSicky)
  },[])  

  return (
    <div
      className={
        navbarSticky ? "sticky top-0 bg-neutral opacity-95 z-10" : "sticky top-0"
      }
    >
      <header className="mx-auto container py-4">
        <div className="h-20 py-2 px-6 flex justify-center items-center">
          <figure className="flex-1">
            <Link to="/">
              <img src={Logo} alt={siteTitle} />
            </Link>
          </figure>
          <button
            className="menu-icon outline-none focus:outline-none"
            type="button"
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            {navbarOpen ? (
              <FaTimes className="text-3xl" />
            ) : (
              <FaBars className="text-3xl" />
            )}
          </button>
        </div>
      </header>
      {/* Nav menu */}
      <div
        className={
          navbarOpen
            ? "transition duration-150 ease-in-out transform absolute w-full h-screen top-0 bg-secondary"
            : "transition duration-150 ease-in-out transform absolute w-full -top-20 -translate-y-full translate-x-0"
        }
      >
        <div className="mx-auto container mt-4">
          <div className="flex flex-row justify-center items-center py-2 px-6 h-20">
            <figure className="flex-1">
              <Link to="/">
                <img src={LogoWhite} alt={siteTitle} />
              </Link>
            </figure>
            <button
              className="menu-icon outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              {navbarOpen ? (
                <FaTimes className="text-3xl text-white" />
              ) : (
                <FaBars className="text-3xl text-white" />
              )}
            </button>
          </div>

          <ul
            className="mx-auto w-full xl:w-3/4 pl-6 pt-8 md:pt-44 bg-none md:bg-img-menu-hand bg-no-repeat bg-right-bottom"
            style={{ backgroundImage: `url(${NavMenuHand})` }}
          >
            <li className="py-3">
              <Link
                to="/about-us"
                className="font-bold text-5xl text-white hover:text-primary transition duration-500 ease-in-out"
              >
                About us
              </Link>
            </li>
            <li className="py-3">
              <Link
                to="/services"
                className="font-bold text-5xl text-white hover:text-primary transition duration-500 ease-in-out"
              >
                Services
              </Link>
            </li>
            <li className="py-3">
              <Link
                to="/careers"
                className="font-bold text-5xl text-white hover:text-primary transition duration-500 ease-in-out"
              >
                Careers
              </Link>
            </li>
            <li className="py-3">
              <Link
                to="/our-partners"
                className="font-bold text-5xl text-white hover:text-primary transition duration-500 ease-in-out"
              >
                Our Partners
              </Link>
            </li>
            <li className="pt-12 pb-8">
              <Link
                to="/contact"
                className="font-bold text-5xl text-primary hover:text-white transition duration-500 ease-in-out outline-none focus:outline-none cursor-pointer"
              >
                Contact Us
              </Link>
            </li>
            <li className="py-3 flex">
              <a
                href="https://www.linkedin.com/company/avalith-net"
                title="Avalith in Linkedin"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin className="text-5xl text-white mx-4 hover:text-primary transition duration-500 ease-in-out" />
              </a>
              <a
                href="https://www.facebook.com/avalith.net"
                title="Avalith in Facebook"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook className="text-5xl text-white mx-4 hover:text-primary transition duration-500 ease-in-out" />
              </a>
              <a
                href="https://www.instagram.com/avalithar"
                title="Avalith in Instagram"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram className="text-5xl text-white mx-4 hover:text-primary transition duration-500 ease-in-out" />
              </a>
              {/* <img src={NavMenuHand} alt="aa" /> */}
              <a
                href="https://twitter.com/HolaAvalith"
                target="_blank"
                title="Avalith in Twitter"
                rel="noreferrer"
              >
                <FaTwitter className="text-5xl text-white mx-4 hover:text-primary transition duration-500 ease-in-out" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
export default Header
